import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import '../shared.css';

const UserCreate = () => {
  const history = useHistory();
  const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage]     = useState('');

  const [formData, setFormData] = useState({
    FirstName: '',
    LastName: '',
    UserName: '',
    ContactNumber: '',
    Email: '',
  });

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, branchId, token, logout]);

  // Auto-generate username from first + last name
  useEffect(() => {
    const generated = `${formData.FirstName.toLowerCase()}_${formData.LastName.toLowerCase()}`.slice(0, 12);
    setFormData(prev => ({ ...prev, UserName: generated }));
  }, [formData.FirstName, formData.LastName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!formData.FirstName)     { setErrorMessage('First Name is required!');     return; }
    if (!formData.LastName)      { setErrorMessage('Last Name is required!');      return; }
    if (!formData.ContactNumber) { setErrorMessage('Contact Number is required!'); return; }
    if (!formData.Email)         { setErrorMessage('Email is required!');          return; }

    const createData = {
      ...formData,
      CreatedBy: userId,
      CompanyId: companyId,
      BranchId: branchId,
      CreatedDate: new Date(),
    };

    postData('UserApi', createData, token)
      .then(() => {
        setSuccessMessage('User created successfully!');
        setTimeout(() => history.push('/UserIndex'), 1000);
      })
      .catch(err => {
        console.error('User Create error:', err);
        setErrorMessage('Failed to create user. Please try again.');
      });
  };

  return (
    <div className="pg-container">
      {/* ── Header ── */}
      <div className="pg-header">
        <h5 className="pg-title">User — Create</h5>
        <div className="pg-action-row">
          <button className="pg-btn pg-btn-success" onClick={handleSubmit}>
            <DoneIcon /> Save
          </button>
          <Link to="/UserIndex" className="pg-btn pg-btn-danger">
            <CloseIcon /> Back to List
          </Link>
        </div>
      </div>

      {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
      {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

      {/* ── Form ── */}
      <div className="pg-card">
        <div className="pg-form-grid pg-form-grid-4">
          <div className="pg-field">
            <label className="pg-label">First Name <span className="req">*</span></label>
            <input className="pg-input" name="FirstName" value={formData.FirstName}
              onChange={handleChange} placeholder="Enter First Name" maxLength={30} />
          </div>

          <div className="pg-field">
            <label className="pg-label">Last Name <span className="req">*</span></label>
            <input className="pg-input" name="LastName" value={formData.LastName}
              onChange={handleChange} placeholder="Enter Last Name" maxLength={30} />
          </div>

          <div className="pg-field">
            <label className="pg-label">User Name</label>
            <input className="pg-input" name="UserName" value={formData.UserName}
              readOnly placeholder="Auto-generated" />
          </div>

          <div className="pg-field">
            <label className="pg-label">Contact Number <span className="req">*</span></label>
            <input className="pg-input" name="ContactNumber" value={formData.ContactNumber}
              onChange={handleChange} placeholder="Enter Contact Number" maxLength={15} />
          </div>

          <div className="pg-field">
            <label className="pg-label">Email <span className="req">*</span></label>
            <input className="pg-input" name="Email" value={formData.Email}
              onChange={handleChange} placeholder="Enter Email" maxLength={40} />
          </div>
        </div>
      </div>

      <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
    </div>
  );
};

export default UserCreate;
